import type { AppointmentColor } from '../../api/appointments'

/**
 * The three colours an appointment can carry. `primary` is the app's main blue
 * and the default; green and yellow are free-meaning markers the clinic assigns
 * however it likes. Yellow gets dark text — white on yellow is unreadable.
 */
export const APPOINTMENT_COLORS: Record<AppointmentColor, {
  label: string
  hex: string
  text: string
}> = {
  primary: { label: 'Main', hex: '#2563eb', text: '#ffffff' },
  green: { label: 'Green', hex: '#16a34a', text: '#ffffff' },
  yellow: { label: 'Yellow', hex: '#eab308', text: '#1f2937' },
}

export const COLOR_ORDER: AppointmentColor[] = ['primary', 'green', 'yellow']

export function colorOf(color: AppointmentColor) {
  return APPOINTMENT_COLORS[color] ?? APPOINTMENT_COLORS.primary
}
